/**
 * @FileDescription: 采供-供应商认证
 * @Author: zhuangjinshan
 * @Date: 2026-01-27
 * @LastEditors: zhuangjinshan
 * @LastEditTime: 2026-01-27
 */
import axios from '@/api/utils/axios';
import BaseApi from '@/api/utils/baseApi.js';

const supplierAuthApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/material/supplier/certification';
	},

};

export default Object.assign(supplierAuthApi, BaseApi);
